var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.824937 4.78122C4.04616 3.37779 6.19414 2.45256 7.26889 2.00553C10.3375 0.729185 10.9751 0.50747 11.3907 0.500071C11.4822 0.498539 11.6865 0.521192 11.8189 0.628617C11.9307 0.719324 11.9615 0.841857 11.9762 0.927857C11.9909 1.01386 12.0092 1.20977 11.9947 1.36285C11.8284 3.11007 11.1088 7.35012 10.7428 9.30704C10.5879 10.1351 10.2829 10.4127 9.98764 10.4399C9.34596 10.4989 8.8587 10.0158 8.2372 9.60843C7.26468 8.97093 6.71527 8.57409 5.77127 7.952C4.68032 7.23308 5.38754 6.83795 6.00927 6.19219C6.17198 6.0232 8.99923 3.4516 9.05395 3.21831C9.06079 3.18913 9.06714 3.08038 9.00253 3.02295C8.93793 2.96553 8.84257 2.98516 8.77375 3.00078C8.67621 3.02292 7.1226 4.0498 4.11292 6.08142C3.67193 6.38424 3.2725 6.53178 2.91462 6.52405C2.52009 6.51553 1.76117 6.30098 1.19699 6.11758C0.504996 5.89264 -0.0449838 5.77372 0.00290711 5.3917C0.0278516 5.19272 0.301862 4.98923 0.824937 4.78122Z",
    fill: "#479ED7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e8afbbffd8cb6325b9a620473ff51e6b.svg";
export { ForwardRef as ReactComponent };